


























































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid';
import DataSource from 'devextreme/data/data_source';
import DevExpress from 'devextreme/bundles/dx.all';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    WindowsServiceContract,
    EventsServiceContract,
    Events
} from '@/core/contracts';
import { ContextsState, ProductsState } from '@/store';
import { encodeParams, lookupField } from '@/core/helpers/utils';
import { StructuredResult, ProductReplacement } from '@/dto';
import {
    Table,
    removeItemsFromView,
    columnTemplates
} from '@/core/components/table';
import { ReplacementsPageArgs } from './types';
import { localize } from '@/core/filters';
import { defaultTableConfig, TableConfig } from '@/core/components/table';
import DataGrid, { IOptions } from 'devextreme/ui/data_grid';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing
    }
})
export default class ReplacementsTable extends Vue {
    @Prop({ default: () => ({}) }) public args:
        | ReplacementsPageArgs
        | undefined;
    @Prop(String) public tableKey!: string;
    @Prop(String) public exportFileName!: string;

    public dataSource = new DataSource({
        key: 'id' as keyof ProductReplacement,
        load: this.load,
        update: () => Promise.resolve()
    });

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get currentProduct() {
        return ProductsState.current;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get defaultTableConfig(): Partial<TableConfig> {
        return defaultTableConfig(this);
    }

    public getDataGridInstance(): DataGrid {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public onRowUpdated(args: { key: any; data: any }) {
        if (args.data.factor) {
            this.updateFactor(args.key, args.data.factor);
        }
        if (args.data.penalty) {
            this.updatePenalty(args.key, args.data.penalty);
        }
        if (args.data.active) {
            this.updateActive(args.key, args.data.active);
        }
    }

    private onProcessingFinished = ({ contextId }: any) => {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.getDataGridInstance().refresh();
        }
    };

    private async load() {
        const currentContextId = ContextsState.currentContextId;
        const url = `/contexts/${currentContextId}/replacements?${encodeParams(
            this.makeFilter()
        )}`;
        const data = await this._fetchService!.get<
            StructuredResult<ProductReplacement>
        >(url);
        if (!data) {
            return {
                data: [],
                totalCount: 0
            };
        }
        this.transform(data);
        const items = data.items || [];

        return {
            data: items,
            totalCount: items.length
        };
    }

    private makeFilter() {
        const filter: any = {};

        if (this.currentProduct) {
            filter.productAlias = this.currentProduct.alias;
        }

        return filter;
    }

    private transform(data: StructuredResult<ProductReplacement>) {
        if (!(data && data.items)) {
            return;
        }

        for (const item of data.items) {
            lookupField(item, 'product', data.products);
            lookupField(item, 'replacement', data.products);

            if (item.typeId) {
                item.type = data.resourceTypes[item.typeId];
            }
        }
    }

    private updateFactor(key: any, factorValue: any) {
        const data: any = {
            replacements_partial: [
                {
                    id: key,
                    factor: factorValue
                }
            ]
        };
        this.updateReplacementField(data);
    }

    private updatePenalty(key: any, penaltyValue: any) {
        const data: any = {
            replacements_partial: [
                {
                    id: key,
                    penalty: penaltyValue
                }
            ]
        };
        this.updateReplacementField(data);
    }

    private updateActive(key: any, activeValue: any) {
        const data: any = {
            replacements_partial: [
                {
                    id: key,
                    active: activeValue
                }
            ]
        };
        this.updateReplacementField(data);
    }

    private updateReplacementField(data: any) {
        this.$emit('processing', true);
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?${encodeParams({
            ignoreWarnings: true
        })}`;
        this._fetchService!.post(url, JSON.stringify(data)).then(() =>
            this.$emit('processing', false)
        );
    }
}
